/* assets/wedyug-mega-menu.js — Wedyug Luxe Crafts custom mega menu */
(function () {
  'use strict';

  var TAG = '[WedyugMegaMenu]';
  var FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var instances = new Map();

  /* Scroll distance from the open position that force-closes the panel. */
  var SCROLL_CLOSE_PX = 90;
  /* Watchdog interval — catches a mouseleave that never fired. */
  var IDLE_CHECK_MS = 400;

  var THEME_CRITICAL =
    'header-drawer, .menu-drawer, menu-drawer, .header__icon--menu, ' +
    '.header__icon--cart, .header__icon--search, .header__icon--account, ' +
    '.header__icon--wishlist, .header__heading, details-modal, cart-drawer, ' +
    'predictive-search, sticky-header';

  var CHEVRON_DOWN =
    '<svg class="wm-nav-chevron" viewBox="0 0 16 16" width="11" height="11" aria-hidden="true" focusable="false">' +
    '<path d="M3.5 6l4.5 4.5L12.5 6" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var CHEVRON_RIGHT =
    '<svg class="wm-acc__caret" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false">' +
    '<path d="M6 3.5L10.5 8L6 12.5" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- helpers ---------- */

  function normalise(str) {
    return (str || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function pathOf(href) {
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/+$/, '').toLowerCase();
    } catch (e) {
      return '';
    }
  }

  function stripped(node) {
    var clone = node.cloneNode(true);
    var junk = clone.querySelectorAll('svg, ul, .visually-hidden, .header__submenu, .mega-menu__content');
    Array.prototype.forEach.call(junk, function (n) { n.remove(); });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function ownLabel(node) { return normalise(stripped(node)); }

  function isCritical(node) {
    if (!node || node.nodeType !== 1) return true;
    if (node.matches && node.matches(THEME_CRITICAL)) return true;
    if (node.querySelector && node.querySelector(THEME_CRITICAL)) return true;
    return false;
  }

  function scrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  /* True only for devices with a real hovering pointer. */
  function hasRealHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function safeMatches(el, sel) {
    try { return !!el && el.matches(sel); } catch (e) { return false; }
  }

  /* Close every open desktop panel. Used by global handlers. */
  function closeAllDesktop(except) {
    instances.forEach(function (inst) {
      if (inst === except) return;
      if (inst.desktop && inst.desktop.isOpen) inst.desktop.close();
    });
  }

  function matchIn(scope, cfg, panel) {
    if (!scope) return [];

    var out = [];
    var sel = (cfg.triggerSelector || '').trim();

    function keep(n) {
      if (!n || panel.contains(n)) return false;
      if (!scope.contains(n)) return false;
      if (isCritical(n)) return false;
      if (n.closest('.wm-acc')) return false;
      if (n.hasAttribute('data-wm-trigger')) return false;
      return true;
    }

    if (sel) {
      try {
        out = Array.prototype.slice.call(document.querySelectorAll(sel)).filter(keep);
      } catch (e) {
        console.error(TAG, 'Invalid trigger CSS selector:', sel, e);
      }
      if (out.length) return out;
    }

    var handle = normalise(cfg.triggerHandle);
    var label = normalise(cfg.triggerText);
    if (!handle && !label) return [];

    var nodes = Array.prototype.slice
      .call(scope.querySelectorAll('a[href], summary'))
      .filter(keep);

    if (handle) {
      out = nodes.filter(function (n) {
        if (n.tagName === 'A') {
          var p = pathOf(n.getAttribute('href'));
          return p === '/collections/' + handle || p === '/pages/' + handle || p === '/' + handle;
        }
        var det = n.parentElement;
        var first = det && det.querySelector('a[href]');
        return !!first && pathOf(first.getAttribute('href')) === '/collections/' + handle;
      });
      if (out.length) return out;
    }

    if (label) {
      out = nodes.filter(function (n) { return ownLabel(n) === label; });
      if (out.length) return out;
    }

    return [];
  }

  /* =======================================================================
     Instance
     ======================================================================= */

  function MegaMenu(root) {
    this.root = root;
    this.panel = root.querySelector('[data-wm-panel]');
    if (!this.panel) {
      console.error(TAG, 'Panel element missing inside section root.');
      return;
    }

    try {
      this.cfg = JSON.parse(root.dataset.wmConfig || '{}');
    } catch (e) {
      this.cfg = {};
      console.error(TAG, 'Config JSON failed to parse.', e);
    }

    this.desktop = null;
    this.mobile = null;
    this.mq = window.matchMedia('(min-width: ' + (this.cfg.breakpoint || 990) + 'px)');

    this.resolveTargets();

    document.body.appendChild(this.panel);
    this.panel.setAttribute('data-wm-ready', '');

    this.syncMode = this.syncMode.bind(this);
    if (this.mq.addEventListener) this.mq.addEventListener('change', this.syncMode);
    else if (this.mq.addListener) this.mq.addListener(this.syncMode);

    this.syncMode();
  }

  MegaMenu.prototype.log = function () {
    if (!this.cfg.debug && !this.cfg.designMode) return;
    console.log.apply(console, [TAG].concat([].slice.call(arguments)));
  };

  MegaMenu.prototype.resolveTargets = function () {
    var sel = this.cfg.headerSelector;

    this.stickyWrap =
      (sel && document.querySelector(sel)) ||
      document.querySelector('.section-header') ||
      document.querySelector('#shopify-section-header') ||
      document.querySelector('header.header') ||
      document.querySelector('header') ||
      null;

    this.inlineNav =
      (this.stickyWrap && this.stickyWrap.querySelector('.header__inline-menu')) ||
      document.querySelector('.header__inline-menu') ||
      null;

    this.drawerMenu =
      document.querySelector('.menu-drawer__navigation > .menu-drawer__menu') ||
      document.querySelector('.menu-drawer__navigation .menu-drawer__menu') ||
      document.querySelector('ul.menu-drawer__menu') ||
      null;
  };

  MegaMenu.prototype.syncMode = function () {
    if (this.mq.matches) {
      if (this.mobile) { this.mobile.destroy(); this.mobile = null; }
      if (!this.desktop) this.desktop = new DesktopMenu(this);
    } else {
      if (this.desktop) { this.desktop.destroy(); this.desktop = null; }
      if (!this.mobile) this.mobile = new MobileList(this);
    }
  };

  MegaMenu.prototype.destroy = function () {
    if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.syncMode);
    else if (this.mq.removeListener) this.mq.removeListener(this.syncMode);

    if (this.desktop) { this.desktop.destroy(); this.desktop = null; }
    if (this.mobile) { this.mobile.destroy(); this.mobile = null; }

    if (this.panel && this.panel.parentNode === document.body) this.panel.remove();
  };

  MegaMenu.prototype.cards = function () {
    return Array.prototype.map.call(
      this.panel.querySelectorAll('.wm-card__link'),
      function (a) {
        var t = a.querySelector('.wm-card__title');
        var img = a.querySelector('img.wm-card__img');
        return {
          href: a.getAttribute('href'),
          title: t ? t.textContent.trim() : a.textContent.trim(),
          src: img ? (img.getAttribute('src') || '') : '',
          srcset: img ? (img.getAttribute('srcset') || '') : ''
        };
      }
    ).filter(function (c) { return c.href && c.title; });
  };

  MegaMenu.prototype.footerLink = function () {
    var a = this.panel.querySelector('.wm-footer__link');

    if (a) {
      var s = a.querySelector('span');
      return {
        href: a.getAttribute('href'),
        title: s ? s.textContent.trim() : a.textContent.trim()
      };
    }

    return { href: '/collections', title: 'View All Collections' };
  };

  /* =======================================================================
     Desktop
     ======================================================================= */

  function DesktopMenu(menu) {
    this.menu = menu;
    this.cfg = menu.cfg;
    this.panel = menu.panel;

    this.isOpen = false;
    this.bound = [];
    this.injectedCarets = [];
    this.openTimer = null;
    this.closeTimer = null;
    this.idleTimer = null;
    this.openScrollY = 0;

    /* Touch / stylus devices get click behaviour regardless of the setting,
       because mouseleave will never fire there. */
    this.hoverCapable = hasRealHover();
    this.mode = (this.cfg.desktopTrigger === 'click' || !this.hoverCapable) ? 'click' : 'hover';

    this.triggers = matchIn(menu.inlineNav, this.cfg, this.panel);

    if (!this.triggers.length) {
      console.warn(TAG, 'No desktop nav item matched. Run WedyugMegaMenu.debug().');
    } else {
      menu.log('Desktop triggers:', this.triggers, '| mode:', this.mode);
    }

    this.wirePanel();
    this.triggers.forEach(this.wireTrigger.bind(this));
    this.wireSiblingNav();
    this.suppressNative();
    this.watchHeader();
    this.wireGlobalSafety();

    if (this.cfg.forceOpen && this.cfg.designMode) this.open();
  }

  DesktopMenu.prototype.on = function (el, evt, fn, opts) {
    el.addEventListener(evt, fn, opts || false);
    this.bound.push([el, evt, fn, opts || false]);
  };

  DesktopMenu.prototype.suppressNative = function () {
    if (!this.cfg.suppressNative) return;
    var self = this;

    this.triggers.forEach(function (t) {
      var det = t.closest('details');
      if (!det || isCritical(det)) return;
      if (!det.closest('.header__inline-menu')) return;

      det.setAttribute('data-wm-suppressed', '');
      if (det.open) det.open = false;
      self.on(det, 'toggle', function () { if (det.open) det.open = false; });
    });
  };

  DesktopMenu.prototype.addCaret = function (trigger) {
    if (trigger.querySelector('svg, .icon-caret, .svg-wrapper')) {
      trigger.classList.add('wm-trigger', 'wm-trigger--native-caret');
      return;
    }
    trigger.classList.add('wm-trigger', 'wm-trigger--injected-caret');
    trigger.insertAdjacentHTML('beforeend', CHEVRON_DOWN);
    var svg = trigger.querySelector('.wm-nav-chevron');
    if (svg) this.injectedCarets.push(svg);
  };

  DesktopMenu.prototype.wireTrigger = function (trigger) {
    var self = this;

    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-controls', this.panel.id);
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('data-wm-trigger', '');

    this.addCaret(trigger);

    var item = trigger.closest('.header__inline-menu li, .list-menu__item') || trigger;
    this.hoverZones = this.hoverZones || [];
    this.hoverZones.push(item);

    if (this.mode === 'hover') {
      this.on(item, 'mouseenter', function () { self.scheduleOpen(trigger); });
      this.on(item, 'mouseleave', function () { self.scheduleClose(); });
    }

    /* In click mode the trigger toggles. In hover mode a click still closes,
       so a stuck panel can always be dismissed by tapping the trigger again. */
    this.on(trigger, 'click', function (e) {
      if (self.mode === 'click') {
        e.preventDefault();
        if (self.isOpen) self.close();
        else self.open(trigger);
      } else if (self.isOpen) {
        self.close();
      }
    });

    this.on(trigger, 'keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        if (e.key !== 'Enter') e.preventDefault();
        self.open(trigger);
        self.focusFirst();
      } else if (e.key === 'Escape') {
        self.close(true);
      }
    });

    this.on(trigger, 'focus', function () {
      if (self.mode === 'hover') self.open(trigger);
    });
  };

  /* Hovering or clicking any OTHER top-level nav item closes this panel. */
  DesktopMenu.prototype.wireSiblingNav = function () {
    var self = this;
    var nav = this.menu.inlineNav;
    if (!nav) return;

    var items = nav.querySelectorAll('a[href], summary');

    Array.prototype.forEach.call(items, function (el) {
      if (el.hasAttribute('data-wm-trigger')) return;

      self.on(el, 'mouseenter', function () { self.close(); });
      self.on(el, 'focus', function () { self.close(); });
      self.on(el, 'click', function () { self.close(); });
    });

    /* Header icons: search, account, cart, wishlist. */
    var icons = self.menu.stickyWrap
      ? self.menu.stickyWrap.querySelectorAll('.header__icons a, .header__icons button, .header__icons summary')
      : [];

    Array.prototype.forEach.call(icons, function (el) {
      self.on(el, 'pointerdown', function () { self.close(); });
    });
  };

  DesktopMenu.prototype.wirePanel = function () {
    var self = this;

    this.on(this.panel, 'mouseenter', function () { self.cancelClose(); });

    this.on(this.panel, 'mouseleave', function () {
      if (self.cfg.forceOpen && self.cfg.designMode) return;
      if (self.mode === 'hover') self.scheduleClose();
    });

    this.on(this.panel, 'click', function (e) {
      if (e.target.closest('[data-wm-close]')) { e.preventDefault(); self.close(true); return; }
      if (e.target.closest('a[href]')) self.close();
    });

    this.on(this.panel, 'keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.close(true); }
    });

    this.on(this.panel, 'focusout', function (e) {
      var next = e.relatedTarget;
      if (!next || self.panel.contains(next) || self.triggers.indexOf(next) !== -1) return;
      self.close();
    });

    /* pointerdown fires for mouse, touch and pen, and fires before any
       navigation — this is the reliable dismissal path. */
    this.outsidePointer = function (e) {
      if (self.panel.contains(e.target)) return;
      if (self.triggers.some(function (t) { return t.contains(e.target); })) return;
      self.close();
    };
  };

  DesktopMenu.prototype.watchHeader = function () {
    var self = this;
    var hdr = this.menu.stickyWrap;
    if (!hdr) return;

    this.onScroll = function () {
      if (!self.isOpen) return;

      /* Any meaningful scroll dismisses the panel — no repositioning games. */
      if (Math.abs(scrollY() - self.openScrollY) > SCROLL_CLOSE_PX) {
        self.close();
        return;
      }
      self.position();
    };

    this.on(window, 'scroll', this.onScroll, { passive: true });
    this.on(window, 'resize', function () { self.close(); });

    if (window.ResizeObserver) {
      this.ro = new ResizeObserver(function () {
        if (self.isOpen) self.position();
      });
      this.ro.observe(hdr);
    }

    if (window.MutationObserver) {
      this.mo = new MutationObserver(function () {
        if (!self.isOpen) return;
        if (self.headerIsGone()) self.close();
        else self.position();
      });
      this.mo.observe(hdr, { attributes: true, attributeFilter: ['class', 'style'] });
    }
  };

  /* Global dismissal paths that must work regardless of pointer state. */
  DesktopMenu.prototype.wireGlobalSafety = function () {
    var self = this;

    this.on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && self.isOpen) self.close(true);
    });

    /* Tab switch / minimise / bfcache navigation. */
    this.on(document, 'visibilitychange', function () {
      if (document.hidden) self.close();
    });

    this.on(window, 'blur', function () { self.close(); });
    this.on(window, 'pagehide', function () { self.close(); });

    /* Pointer left the document entirely. */
    this.on(document, 'mouseleave', function () {
      if (self.mode === 'hover') self.scheduleClose();
    });
  };

  /* True when the header is off-screen or hidden by any mechanism. */
  DesktopMenu.prototype.headerIsGone = function () {
    var hdr = this.menu.stickyWrap;
    if (!hdr) return false;

    if (hdr.classList.contains('shopify-section-header-hidden')) return true;

    var rect = hdr.getBoundingClientRect();
    if (rect.bottom <= 0) return true;                    // scrolled past
    if (rect.height === 0 || rect.width === 0) return true; // collapsed

    var cs = getComputedStyle(hdr);
    if (cs.display === 'none' || cs.visibility === 'hidden') return true;

    return false;
  };

  DesktopMenu.prototype.scheduleOpen = function (trigger) {
    var self = this;
    this.cancelClose();
    clearTimeout(this.openTimer);
    this.openTimer = setTimeout(function () { self.open(trigger); }, this.cfg.openDelay || 0);
  };

  DesktopMenu.prototype.scheduleClose = function () {
    var self = this;
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(function () { self.close(); }, this.cfg.closeDelay || 0);
  };

  DesktopMenu.prototype.cancelClose = function () { clearTimeout(this.closeTimer); };

  /* Watchdog: if nothing is hovered and no focus is inside, close.
     Catches the case where mouseleave was swallowed. */
  DesktopMenu.prototype.startIdleWatch = function () {
    var self = this;
    this.stopIdleWatch();

    if (this.mode !== 'hover') return;

    this.idleTimer = setInterval(function () {
      if (!self.isOpen) { self.stopIdleWatch(); return; }
      if (self.cfg.forceOpen && self.cfg.designMode) return;

      if (safeMatches(self.panel, ':hover')) return;

      var overZone = (self.hoverZones || []).some(function (z) { return safeMatches(z, ':hover'); });
      if (overZone) return;

      if (self.panel.contains(document.activeElement)) return;
      if (self.triggers.indexOf(document.activeElement) !== -1) return;

      self.close();
    }, IDLE_CHECK_MS);
  };

  DesktopMenu.prototype.stopIdleWatch = function () {
    if (this.idleTimer) { clearInterval(this.idleTimer); this.idleTimer = null; }
  };

  DesktopMenu.prototype.open = function (trigger) {
    this.cancelClose();
    if (this.isOpen) { this.position(); return; }

    /* Never open against a header that isn't visible. */
    if (this.headerIsGone() && !(this.cfg.forceOpen && this.cfg.designMode)) return;

    closeAllDesktop(this.menu);

    this.activeTrigger = trigger || this.triggers[0] || null;
    this.isOpen = true;
    this.openScrollY = scrollY();

    this.position();
    void this.panel.offsetHeight;

    this.panel.classList.add('is-open');
    this.triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });

    document.addEventListener('pointerdown', this.outsidePointer, true);
    document.addEventListener('click', this.outsidePointer, true);

    this.startIdleWatch();
  };

  DesktopMenu.prototype.close = function (returnFocus) {
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
    this.stopIdleWatch();

    if (!this.isOpen) return;
    if (this.cfg.forceOpen && this.cfg.designMode) return;

    this.isOpen = false;
    this.panel.classList.remove('is-open');
    this.triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });

    document.removeEventListener('pointerdown', this.outsidePointer, true);
    document.removeEventListener('click', this.outsidePointer, true);

    if (returnFocus && this.activeTrigger) this.activeTrigger.focus();
  };

  DesktopMenu.prototype.position = function () {
    if (!this.isOpen) return;

    var hdr = this.menu.stickyWrap;
    if (!hdr) return;

    if (this.headerIsGone()) { this.close(); return; }

    var rect = hdr.getBoundingClientRect();
    var offset = parseFloat(getComputedStyle(this.panel).getPropertyValue('--wm-offset')) || 0;

    this.panel.style.setProperty('--wm-anchor-top', Math.max(0, rect.bottom + offset) + 'px');
  };

  DesktopMenu.prototype.focusable = function () {
    return Array.prototype.filter.call(
      this.panel.querySelectorAll(FOCUSABLE),
      function (el) { return el.offsetParent !== null; }
    );
  };

  DesktopMenu.prototype.focusFirst = function () {
    var els = this.focusable();
    if (els.length) els[0].focus();
  };

  DesktopMenu.prototype.destroy = function () {
    this.cfg.forceOpen = false;
    this.close();
    this.stopIdleWatch();

    document.removeEventListener('pointerdown', this.outsidePointer, true);
    document.removeEventListener('click', this.outsidePointer, true);

    if (this.ro) this.ro.disconnect();
    if (this.mo) this.mo.disconnect();

    this.bound.forEach(function (h) { h[0].removeEventListener(h[1], h[2], h[3]); });
    this.bound = [];

    this.injectedCarets.forEach(function (svg) { if (svg.parentNode) svg.remove(); });
    this.injectedCarets = [];

    this.triggers.forEach(function (t) {
      t.removeAttribute('aria-haspopup');
      t.removeAttribute('aria-controls');
      t.removeAttribute('aria-expanded');
      t.removeAttribute('data-wm-trigger');
      t.classList.remove('wm-trigger', 'wm-trigger--native-caret', 'wm-trigger--injected-caret');
      var det = t.closest('details[data-wm-suppressed]');
      if (det) det.removeAttribute('data-wm-suppressed');
    });

    this.triggers = [];
    this.hoverZones = [];
    this.panel.style.removeProperty('--wm-anchor-top');
  };

  /* =======================================================================
     Mobile
     ======================================================================= */

  function MobileList(menu) {
    this.menu = menu;
    this.cfg = menu.cfg;
    this.bound = [];
    this.injected = null;
    this.hidden = [];
    this.host = null;

    if (!menu.drawerMenu) {
      menu.log('menu-drawer__menu not found; mobile list skipped.');
      return;
    }

    var target = matchIn(menu.drawerMenu, this.cfg, menu.panel)[0];
    if (!target) {
      menu.log('No drawer item matched; mobile list skipped.');
      return;
    }

    this.build(target);
  }

  MobileList.prototype.on = function (el, evt, fn) {
    el.addEventListener(evt, fn);
    this.bound.push([el, evt, fn]);
  };

  MobileList.prototype.hideOrigin = function (target) {
    var node = target;
    var det = target.closest('details');

    if (det &&
        this.menu.drawerMenu.contains(det) &&
        !isCritical(det) &&
        det !== this.menu.drawerMenu) {
      node = det;
    }

    if (isCritical(node)) {
      this.menu.log('Refusing to hide a theme-critical node.', node);
      return null;
    }

    node.classList.add('wm-origin-hidden');
    this.hidden.push(node);
    return node;
  };

  MobileList.prototype.build = function (target) {
    var self = this;
    var cards = this.menu.cards();

    if (!cards.length) {
      this.menu.log('No cards to render on mobile.');
      return;
    }

    var li = target.closest('li');

    if (!li || li.parentElement !== this.menu.drawerMenu) {
      this.menu.log('Not a top-level drawer item; mobile list skipped.');
      return;
    }

    if (li.hasAttribute('data-wm-acc-host')) {
      this.menu.log('This drawer item already hosts an accordion; skipped.');
      return;
    }

    li.setAttribute('data-wm-acc-host', '');
    this.host = li;

    var hiddenNode = this.hideOrigin(target);
    if (!hiddenNode) {
      li.removeAttribute('data-wm-acc-host');
      this.host = null;
      return;
    }

    var id = 'WmAcc-' + (this.cfg.sectionId || Math.random().toString(36).slice(2));
    var labelText = stripped(target) || 'Collections';

    var wrap = document.createElement('div');
    wrap.className = 'wm-acc';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wm-acc__toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id);
    btn.innerHTML = '<span class="wm-acc__label"></span>' + CHEVRON_DOWN;
    btn.querySelector('.wm-acc__label').textContent = labelText;

    var region = document.createElement('div');
    region.className = 'wm-acc__region';
    region.id = id;

    var inner = document.createElement('div');
    inner.className = 'wm-acc__inner';

    var list = document.createElement('ul');
    list.className = 'wm-acc__list';
    list.setAttribute('role', 'list');

    cards.forEach(function (c) {
      var item = document.createElement('li');
      item.className = 'wm-acc__item';

      var a = document.createElement('a');
      a.className = 'wm-acc__row';
      a.href = c.href;

      var thumb = document.createElement('span');
      thumb.className = 'wm-acc__thumb';

      if (c.src) {
        var img = document.createElement('img');
        img.className = 'wm-acc__img';
        img.src = c.src;
        if (c.srcset) img.srcset = c.srcset;
        img.sizes = '76px';
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        thumb.appendChild(img);
      } else {
        thumb.classList.add('wm-acc__thumb--empty');
      }

      var name = document.createElement('span');
      name.className = 'wm-acc__name';
      name.textContent = c.title;

      a.appendChild(thumb);
      a.appendChild(name);
      a.insertAdjacentHTML('beforeend', CHEVRON_RIGHT);

      item.appendChild(a);
      list.appendChild(item);
    });

    inner.appendChild(list);

    var footer = this.menu.footerLink();
    if (footer && footer.href && footer.title) {
      var all = document.createElement('a');
      all.className = 'wm-acc__all';
      all.href = footer.href;
      all.innerHTML =
        '<span></span>' +
        '<svg class="wm-acc__all-arrow" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false">' +
        '<path d="M2 8h11M9 4l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.5" ' +
        'stroke-linecap="round" stroke-linejoin="round"/></svg>';
      all.querySelector('span').textContent = footer.title;
      inner.appendChild(all);
    }

    region.appendChild(inner);
    wrap.appendChild(btn);
    wrap.appendChild(region);

    li.appendChild(wrap);
    this.injected = wrap;

    this.on(btn, 'click', function (e) {
      e.preventDefault();
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      wrap.classList.toggle('is-open', !open);
    });

    this.menu.log('Mobile list injected with', cards.length, 'rows into', li);
  };

  MobileList.prototype.destroy = function () {
    this.bound.forEach(function (h) { h[0].removeEventListener(h[1], h[2]); });
    this.bound = [];

    if (this.injected && this.injected.parentNode) this.injected.remove();
    this.injected = null;

    this.hidden.forEach(function (n) { n.classList.remove('wm-origin-hidden'); });
    this.hidden = [];

    if (this.host) {
      this.host.removeAttribute('data-wm-acc-host');
      this.host = null;
    }
  };

  /* =======================================================================
     Boot
     ======================================================================= */

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-wm-root]');
    Array.prototype.forEach.call(roots, function (root) {
      if (instances.has(root)) return;
      instances.set(root, new MegaMenu(root));
    });
  }

  function reap() {
    instances.forEach(function (inst, root) {
      if (!document.body.contains(root)) {
        if (inst.destroy) inst.destroy();
        instances.delete(root);
      }
    });
  }

  window.WedyugMegaMenu = {
    instances: instances,
    closeAll: function () { closeAllDesktop(null); },
    debug: function () {
      if (!instances.size) {
        console.warn(TAG, 'No instances. data-wm-root nodes in DOM:',
          document.querySelectorAll('[data-wm-root]').length);
        return;
      }
      instances.forEach(function (i) {
        console.group(TAG + ' — ' + (i.cfg ? i.cfg.sectionId : '?'));
        console.log('mode:', i.mq.matches ? 'desktop' : 'mobile');
        console.log('hover capable:', hasRealHover());
        console.log('trigger mode:', i.desktop ? i.desktop.mode : '(mobile)');
        console.log('is open:', i.desktop ? i.desktop.isOpen : false);
        console.log('header gone:', i.desktop ? i.desktop.headerIsGone() : 'n/a');
        console.log('header:', i.stickyWrap);
        console.log('inline nav:', i.inlineNav);
        console.log('drawer <ul>:', i.drawerMenu);
        console.log('cards:', i.cards().length);
        console.log('desktop triggers:', i.desktop ? i.desktop.triggers : '(mobile mode)');
        console.log('mobile accordion:', i.mobile ? i.mobile.injected : '(desktop mode)');
        console.groupEnd();
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Any full page navigation leaves nothing open behind. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) closeAllDesktop(null);
  });

  document.addEventListener('shopify:section:load', function (e) {
    reap();
    boot(e.target);
    boot();
  });

  document.addEventListener('shopify:section:unload', function (e) {
    instances.forEach(function (inst, root) {
      if (e.target.contains(root)) {
        if (inst.destroy) inst.destroy();
        instances.delete(root);
      }
    });
  });

  document.addEventListener('shopify:section:select', function (e) {
    instances.forEach(function (inst, root) {
      if (e.target.contains(root) && inst.desktop) inst.desktop.open();
    });
  });

  document.addEventListener('shopify:section:deselect', function (e) {
    instances.forEach(function (inst, root) {
      if (e.target.contains(root) && inst.desktop && !inst.cfg.forceOpen) inst.desktop.close();
    });
  });
})();